export default __webpack_public_path__ + "static/media/MLBPopupBg.e8739a8e.png";